import { formatNumber } from "shelving";
import { useMount } from "shelving/react";

export interface NumberProps {
	from: number;
	to: number;
	duration?: number | undefined;
	paused?: boolean | undefined;
	formatter?: ((num: number) => string) | undefined;
	mods?: string | undefined;
	prefix?: string | undefined;
	suffix?: string | undefined;
}

/** Show a number, with optional animation from/to a given value. */
export function Number({
	from, //
	to,
	formatter = formatNumber,
	duration = 1000,
	paused = false,
	mods,
	prefix = "",
	suffix = "",
}: NumberProps): React.ReactElement {
	return (
		<data className={mods} ref={useMount(_animateNumber, from, to, duration, paused, prefix, formatter, suffix)} value={to}>
			{`${prefix}${formatter(from)}${suffix}`}
		</data>
	);
}

function _animateNumber(el: HTMLElement, from: number, to: number, duration: number, paused: boolean, prefix: string, formatter: (num: number) => string, suffix: string) {
	if (paused || to === from) return;
	let handle: number;
	let start: number;
	const frame: FrameRequestCallback = now => {
		if (!start) start = now;
		const num = from + ((to - from) * (now - start)) / duration;
		el.innerHTML = `${prefix}${formatter(num)}${suffix}`;
		if ((to > from && num < to) || (to < from && num > to)) handle = requestAnimationFrame(frame);
	};
	requestAnimationFrame(frame);
	return () => cancelAnimationFrame(handle);
}
